export default "__VITE_ASSET__CcNwLlpL__"